// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLGlobalStatus } from '../../modules/koh-lanta/selectors/global';
import { selectIsKLEnabled } from '../../modules/koh-lanta/selectors/runtime';
import { selectHasUserNeverOptIn } from '../../modules/koh-lanta/selectors/user';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserDidReceivedUserData } from '../../selectors/user/userPrimary.selector';
import { Licences } from '../../types/common';

const selectIsLicenceES = createSelector(selectRuntimeLicence, (licence) => licence === Licences.ES);

const selectAppProps = createSelector(
  [selectUserDidReceivedUserData, selectIsKLEnabled, selectKLGlobalStatus, selectHasUserNeverOptIn, selectIsLicenceES],
  (didUserReceiveData, isKLEnabled, klGlobalStatus, klHasUserNeverOptIn, isLicenceES) => ({
    didUserReceiveData,
    isKLEnabled,
    klGlobalStatus,
    klHasUserNeverOptIn,
    isLicenceES,
  }),
);

export default selectAppProps;
